import Vue from 'vue';
import Vuex from 'vuex';

import auth from "./modules/auth";
import alerts from "./modules/alerts-module";
import profile from "./modules/profile-module";
import users from "./modules/users-module";
import roles from "./modules/roles-module";
import categories from "./modules/categories-module";
import tags from "./modules/tags-module";
import items from "./modules/items-module";
import organizations from "./modules/organizations-module";
import hardwares from "./modules/hardwares-module";
import softwares from "./modules/softwares/software-module";
import softwaresCategories from "./modules/softwares/categorie-module";

import licences from "./modules/licences-module";
import versions from "./modules/versions-module";
import files from "./modules/files-module";
import images from "./modules/images-module";
import works from "./modules/works-module";


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    alerts,
    profile,
    users,
    roles,
    categories,
    tags,
    items,
    organizations,
    hardwares,
    softwares,
    softwaresCategories,
    licences,
    versions,
    works,
    files,
    images
  }
});
